import {Pipe, PipeTransform} from '@angular/core';
import {Coupon} from '../generated-admin-types';
import {MARK_UP_STATES} from './state.pipe';

@Pipe({
  name: 'couponStatus',
})
export class CouponStatusPipe implements PipeTransform {
  transform(value: Coupon): string {
    if (value.state !== 'normal') {
      return MARK_UP_STATES[value.state!];
    } else {
      if (!value.enable) {
        return '下架';
      } else {
        return MARK_UP_STATES[value.state];
      }
    }
  }
}
